var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49999 12.8485C2.99374 12.8485 0.15155 10.0063 0.15155 6.50005C0.15155 2.9938 2.99374 0.151611 6.49999 0.151611C10.0062 0.151611 12.8484 2.9938 12.8484 6.50005C12.8484 10.0063 10.0062 12.8485 6.49999 12.8485ZM6.49999 0.842238C3.39218 0.842238 0.842175 3.39223 0.842175 6.50005C0.842175 9.60786 3.39218 12.1579 6.49999 12.1579C9.6078 12.1579 12.1578 9.60786 12.1578 6.50005C12.1578 3.39223 9.6078 0.842238 6.49999 0.842238Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36716 10.1392L5.88904 9.63452L8.99685 6.50015L5.88904 3.36578L6.36716 2.86108L10.0062 6.50015L6.36716 10.1392Z",
    fill: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50156 6.87192H3.12656V6.12817H9.50156V6.87192Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLeftArrow);
export default __webpack_public_path__ + "static/media/red_left_arrow.673c4e7ec77d77147d0005419238336c.svg";
export { ForwardRef as ReactComponent };